module.exports = "<div class=\"wh-insights-search-results-item wh-insights-search-results-item--blog wh-insights-search-results-item--<%= Theme %>\"> <div class=wh-insights-search-results-item__image style=\"background-image:url(<%= Image.Src %>)\"></div> <a href=\"<%= Link.Url %>\" class=wh-insights-search-results-item__content> <h3 class=wh-insights-search-results-item__title> <%= Title %> </h3> <span class=\"wh-insights-search-results-item__cta btn--new-page\"><%= Link.Label %></span> </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/templates/search-insights-blog-item.html
// module id = 607
// module chunks = 64